import { useTaskDates } from 'composables/useTaskDates.js'

// Axis labels for the stats charts. The server hands back plain 'YYYY-MM-DD'
// bucket starts, and turning those into readable labels must not go through
// `new Date(str)` + local getters: that reinterprets a calendar date in the
// browser's zone and can shift it a day for anyone whose browser and account
// disagree. Pinning to midday UTC and formatting in UTC keeps the label
// identical to the date the server actually bucketed.
export function useChartLabels() {
  const { dateStrInUserTz } = useTaskDates()

  function bucketLabel(dateStr, bucket) {
    const at = new Date(`${dateStr}T12:00:00Z`)
    if (bucket === 'month') {
      return new Intl.DateTimeFormat('en-US', { month: 'short', year: '2-digit', timeZone: 'UTC' }).format(at)
    }
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(at)
  }

  return { bucketLabel, dateStrInUserTz }
}
